import TakeOrPickImage from '@fabric-app/business/mediaRecording/components/TakeOrPickImage';
import { blobToBase64, resizeImage } from '@fabric-app/utils/files';
import type React from 'react';
import { SearchBarButton } from './SearchbarButton';
import { searchBarMotionLayoutIdProps } from '../searchbar.config';
import { IconNavigational24Camera } from '@fabric-app/icons/svg';

type AddImageButtonProps = {
  onSetImageURL: (url: string) => void;
};

const AddImageButton: React.FC<AddImageButtonProps> = ({ onSetImageURL }) => {
  const onSetImages = async (images: File[]) => {
    const image = images[0];

    if (!image) {
      return;
    }

    onSetImageURL?.(await resizeImage(image, 512).then(blobToBase64));
  };

  return (
    <TakeOrPickImage
      onSetImages={onSetImages}
      limit={1}
      renderTriggerElement={({ onOpenChange }) => (
        <SearchBarButton
          {...searchBarMotionLayoutIdProps.addImageButton}
          onClick={() => onOpenChange(true)}
        >
          <IconNavigational24Camera />
        </SearchBarButton>
      )}
    />
  );
};

export default AddImageButton;
